import { Directive, HostListener, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appCardNumberFormatter]',
  standalone: true,
})
export class CardNumberFormatterDirective {
  private el = inject(ElementRef);

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const formattedValue = input.value.replace(/\D/g, '');
    input.value = formattedValue;
  }
}
